import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

export const usePendingRequests = () => {
  const [pendingCount, setPendingCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const { user, token, loading: authLoading } = useAuth();

  const fetchPendingCount = async () => {
    if (!user || !token) {
      setPendingCount(0);
      setLoading(false);
      return;
    }

    try {
      const response = await axios.get('/api/users/pending-requests-count', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      setPendingCount(response.data.count);
    } catch (error) {
      console.error('Error fetching pending requests count:', error);
      setPendingCount(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Attendre que l'authentification soit complètement initialisée
    if (authLoading) {
      return;
    }

    if (!user || !token) {
      setPendingCount(0);
      setLoading(false);
      return;
    }

    // Attendre un peu pour s'assurer que le token est bien configuré
    const timeoutId = setTimeout(() => {
      fetchPendingCount();
    }, 100);
    
    // Rafraîchir toutes les 30 secondes
    const interval = setInterval(fetchPendingCount, 30000);
    
    return () => {
      clearTimeout(timeoutId);
      clearInterval(interval);
    };
  }, [user, token, authLoading]);

  return { pendingCount, loading, refetch: fetchPendingCount };
}; 